// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Whether `PTRideLeg's` should include `CompoundTrain's`(aka formation, composition). However, `CompoundTrain's` at any `ScheduledStopPoint` on the `ServiceJourney` may be loaded separately by `/v3/vehicle-journeys/by-stoppoints`.
 * Possible values:
 * - NONE none at all, though a `PTRideLeg::trainStopAssignmentHint` is always given.
 * - ORIGIN  `TrainStopAssignment's` are added to first (departure) `ScheduledStopPoint` of each `PTRideLeg` 
 * - ORIGIN_DESTINATION `TrainStopAssignment's` are added to first (departure) and last (arrival) `ScheduledStopPoint` of each `PTRideLeg` having a `TrainStopAssignment` resp. a `CompoundTrain`.
 * @export
 */
export const TrainStopAssignmentsEnum = {
    None: 'NONE',
    Origin: 'ORIGIN',
    OriginDestination: 'ORIGIN_DESTINATION'
} as const;
export type TrainStopAssignmentsEnum = typeof TrainStopAssignmentsEnum[keyof typeof TrainStopAssignmentsEnum];


export function instanceOfTrainStopAssignmentsEnum(value: any): boolean {
    for (const key in TrainStopAssignmentsEnum) {
        if (Object.prototype.hasOwnProperty.call(TrainStopAssignmentsEnum, key)) {
            if (TrainStopAssignmentsEnum[key as keyof typeof TrainStopAssignmentsEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TrainStopAssignmentsEnumFromJSON(json: any): TrainStopAssignmentsEnum {
    return TrainStopAssignmentsEnumFromJSONTyped(json, false);
}

export function TrainStopAssignmentsEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainStopAssignmentsEnum {
    return json as TrainStopAssignmentsEnum;
}

export function TrainStopAssignmentsEnumToJSON(value?: TrainStopAssignmentsEnum | null): any {
    return value as any;
}

export function TrainStopAssignmentsEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): TrainStopAssignmentsEnum {
    return value as TrainStopAssignmentsEnum;
}

